import { gql } from "urql";
export const CreateConditionMutation = gql `
    mutation CreateCondition($name: String!) {
        conditions {
            createCondition(name: $name) {
                conditionId
                name
                isActive
            }
        }
    }
`;
export const UpdateConditionMutation = gql `
    mutation UpdateCondition(
        $conditionId: String!
        $name: String
        $isActive: Boolean
    ) {
        conditions {
            updateCondition(
                conditionId: $conditionId
                name: $name
                isActive: $isActive
            ) {
                conditionId
                name
                isActive
            }
        }
    }
`;
export const DeleteConditionMutation = gql `
    mutation DeleteCondition($conditionId: String!) {
        conditions {
            deleteCondition(conditionId: $conditionId) {
                conditionId
            }
        }
    }
`;
